import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { getUnreadCount, NOTIFICATION_READ_EVENT } from '../services/notificationService';
import './NotificationBell.css';

const NotificationBell = ({ variant = 'icon' }) => {
  const { token, isAuthenticated } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!isAuthenticated || !token) return;

    const fetchUnreadCount = async () => {
      const count = await getUnreadCount(token);
      setUnreadCount(count);
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    window.addEventListener(NOTIFICATION_READ_EVENT, fetchUnreadCount);

    return () => {
      clearInterval(interval);
      window.removeEventListener(NOTIFICATION_READ_EVENT, fetchUnreadCount);
    };
  }, [isAuthenticated, token]);

  if (!isAuthenticated) return null;

  return (
    <div className={`notification-bell${variant === 'menu' ? ' notification-bell--menu' : ''}`}>
      <button
        className={`notification-bell-button${variant === 'menu' ? ' navbar__panel-item' : ''}`}
        onClick={() => navigate('/me/notifications')}
        aria-label="Notifications"
        data-testid="notification-bell"
      >
        <Bell size={18} />
        {variant === 'menu' && <span>Notifications</span>}
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </button>
    </div>
  );
};

export default NotificationBell;
